import React from "react";

const Logo = ({ color, style }) => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_1050_1313)">
        <path
          d="M26.5454 25.6586V27.8719C26.4753 28.1562 26.4276 28.4481 26.3328 28.7239C25.7404 30.4434 24.2443 31.4973 22.4038 31.5012C17.609 31.5012 12.8141 31.5012 8.01922 31.5012C7.90829 31.5012 7.79812 31.5012 7.68719 31.4927C5.87139 31.401 4.26128 30.022 3.97316 28.2301C3.85452 27.4867 3.89612 26.7171 3.88071 25.959C3.86839 25.3427 4.18887 25.0346 4.80132 25.0346C8.49917 25.0346 12.195 25.0346 15.8887 25.0346C16.1554 25.0312 16.4152 25.1189 16.6252 25.2834C17.4012 25.8715 18.1796 26.4559 18.9602 27.0368C19.0588 27.1138 19.159 27.1824 19.2607 27.2563C20.1512 26.5853 21.0225 25.9313 21.8923 25.2741C22.1025 25.1099 22.3628 25.0228 22.6296 25.0276C23.5964 25.0346 24.5632 25.0446 25.5285 25.0276C26.0254 25.0138 26.3682 25.1856 26.5454 25.6586Z"
          fill={color}
        />
        <path
          d="M30.0123 5.20785C29.7812 6.0884 29.5501 6.96741 29.3267 7.8495C28.4962 11.1622 27.6693 14.4748 26.846 17.7875C26.7983 17.9816 26.7228 18.044 26.5202 18.044C18.9966 18.0383 11.4725 18.0366 3.94789 18.0386C3.88164 18.0386 3.81462 18.0324 3.71678 18.0271C3.5627 17.4269 3.40863 16.8252 3.25994 16.222C2.35859 12.6207 1.45981 9.01894 0.563594 5.41662C0.50783 5.23367 0.488463 5.04156 0.506586 4.85116C0.611359 4.20404 1.35786 3.9267 1.89328 4.33731C2.7407 4.99599 3.57811 5.67547 4.4186 6.34725L8.01861 9.22849C8.53014 9.63756 8.60564 9.88717 8.39841 10.5012C8.25456 10.9087 8.26738 11.3553 8.43439 11.7539C8.6014 12.1526 8.91066 12.4749 9.30207 12.6582C9.68416 12.8377 10.1186 12.8718 10.524 12.7541C10.9294 12.6364 11.278 12.375 11.5046 12.0188C11.7352 11.6591 11.8248 11.227 11.7563 10.8053C11.6878 10.3836 11.4659 10.002 11.1333 9.73386C10.6271 9.31323 10.557 8.98812 10.849 8.40263C12.0303 6.03396 13.2131 3.66451 14.3974 1.29429C14.5777 0.930672 14.8234 0.668741 15.2448 0.66797C15.6662 0.6672 15.9174 0.925279 16.0984 1.28967C17.2797 3.66092 18.4622 6.0301 19.646 8.39724C19.9395 8.98504 19.8687 9.3217 19.3695 9.73078C19.0355 9.99812 18.8126 10.3797 18.7435 10.8019C18.6745 11.224 18.7644 11.6568 18.9958 12.0165C19.2211 12.3735 19.5688 12.6361 19.9738 12.7552C20.3788 12.8743 20.8133 12.8418 21.196 12.6636C21.5836 12.4842 21.8916 12.1683 22.0611 11.7762C22.2306 11.3842 22.2499 10.9435 22.1151 10.5381C21.8986 9.8679 21.961 9.65605 22.5003 9.22001C24.4802 7.63456 26.4603 6.05014 28.4407 4.46674C29.101 3.93902 29.6264 4.05458 30.0123 4.80571V5.20785Z"
          fill={color}
        />
        <path
          d="M3.95703 19.7939H26.5455V20.0882C26.5455 20.7993 26.5455 21.5104 26.5455 22.2214C26.5455 22.9094 26.2057 23.2476 25.517 23.2476H5.02479C4.28137 23.2476 3.96089 22.9225 3.96012 22.169C3.96012 21.4772 3.96012 20.7857 3.96012 20.0944L3.95703 19.7939Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1050_1313">
          <rect
            width="29.5142"
            height="30.8316"
            fill="white"
            transform="translate(0.498047 0.670898)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
